<template>
    <a-textarea
        :disabled="disabled"
        :value="modelValue"
        :placeholder="this.placeholder"
        :rows="rows"
        :auto-size="{ minRows: min, maxRows: max }"
        @input="updateValue"
    />
</template>

<script>
export default {
    props: {
        modelValue: [String, Number],
        disabled: false,
        rows: {
            type: Number,
            default: 4,
        },
        min: {
            type: Number,
            default: 4,
        },
        max: {
            type: Number,
            default: 8,
        },
        placeholder: {
            type: String,
            default: '',
        },
        formatter: {
            type: Function,
            default: (value) => value,
        },
    },
    methods: {
        updateValue(event) {
            let value = event.target.value;

            value = this.formatter(value);

            this.$emit('update:modelValue', value);
        },
    },
};
</script>
